import { Injectable } from '@angular/core';
import { CommonService } from './common.service';

import * as _ from 'lodash';
@Injectable({
    providedIn: 'root'
})
export class LwActionsExecutor {
    data: any = []

    constructor(private commonService:CommonService){}
    /**this method is main function which will be called from outside of the class
    * @return {[cb]}
    */
    execute(actions: any, data: any, service:any, cb: any) {
        /**Execute is the main method
           it take event name and data associated to it as parameter**/
        this.data = data;
        var mandatoryActionsToPerform = [];
        var mandatoryActionsMap = {};
        var notesParameter = {};

        if (actions && actions.length) {
            var workflowPromises:any = [];

            let body: HTMLElement = document.body
            var params = {};
            for (var item = 0; item < actions.length; item++) {
                if (actions[item]) {
                    //type 1 is basically used for actions related to custom_field_renderer.Later it got depricated and
                    // type 2 will be used for all coming actions in future.
                    if (actions[item].type == 1 || !actions[item].type) {

                        /** This block is for Mandatory Rules: OpenPopup
                         *   Comment out the below code: 
                         *   Instead, maintaining array which will contains all the actions to be performed.
                         *   Will process them all in the end
                         */

                        if (actions[item].action == "openLWNotes") {
                            notesParameter['issueDetail'] = data;
                            notesParameter['issueId'] = data._id;
                            notesParameter['brandDetail'] = this.data.brandDetail;
                            notesParameter['action'] = actions[item];
                            notesParameter['selectedStatus'] = data.status_id_list;
                        } else {
                            if (actions[item].options.group_id) {
                                // To avoid Duplicate Data
                                if (!mandatoryActionsMap[actions[item].options.group_id]) {
                                    mandatoryActionsToPerform = mandatoryActionsToPerform.concat(actions[item]);
                                    mandatoryActionsMap[actions[item].options.group_id] = true;
                                }
                            }
                        }
                    } else if (actions[item].type == 2 && actions[item].action) {
                        /**
                         * To make it generic and reduce complexity we have introduced type 2 which will be used for
                         * all the actions other than custom field renderer.Type 1 is the depricated one.
                         */
                        var actionClassName = actions[item].action;
                        params['action'] = actions[item];
                        params['data'] = data;
                        //creating instance of class dynamically
                        // var actionInstance:any = new window[actionClassName](params);
                        // var promise = $q.defer();
                        // workflowPromises.push(actionInstance._execute(promise));
                    } else {
                        console.warn("LW-UI-RULE:Invalid Action Setup")
                        cb("LW-UI-RULE:Invalid Action Setup", null);
                        return;
                    }
                } else {
                    console.log("No Action in rule")
                    cb("No Action in rule", null);
                    return;
                }
            }

            var errorList:any = [];
            try {

                var params = {};
                if (_.get(mandatoryActionsToPerform, "0.options.group_id") == "ltms_custom_field_siblings") {
                    params = {
                        "issueDetail": data,
                        "issueId": data._id,
                        "brandDetail": this.data.brandDetail,
                        "action": mandatoryActionsToPerform[0],
                        "selectedStatus": data.status_id_list
                    }
                } else if (_.get(mandatoryActionsToPerform, "length") && !_.isEmpty(notesParameter)) {
                    params = this.prepareParamForMandatoryRule(mandatoryActionsToPerform, this.data.brandDetail, data, true);
                    this.prepareNotesParamForMultipleAccordion(params, notesParameter);
                } else if (_.get(mandatoryActionsToPerform, "length")) {
                    params = this.prepareParamForMandatoryRule(mandatoryActionsToPerform, this.data.brandDetail, data);
                } else if (!_.isEmpty(notesParameter)) {
                    params = notesParameter;
                }

                if (!_.isEmpty(params)) {
                    console.log("lw3 action executor aprams",params)
                    // this.LtmsCustomFieldRenderer.init(params);
                    workflowPromises.push( this.commonService.renderCustomFieldsWithAction(params, service));
                }

                Promise.all(workflowPromises).then(function (promiseData) {
                    _.each(promiseData, function (d:any) {
                        if (d.error) {
                            errorList.push(d.error);
                        }
                    })
                    if (!(errorList && errorList.length)) {
                        return cb(null, promiseData);
                    } else {
                        return cb(errorList, null);
                    }
                })
            } catch (e) {
                console.log("Exeception occured: ", e)
                return cb(null, [])
            }

        } else {
            console.warn("No UI Rules are configured in the Brand");
            return cb(null, true);
        }
    }



    prepareNotesParamForMultipleAccordion(mandatoryParameters:any, notesParameter:any) {
        var parametersToUpdate = _.get(mandatoryParameters, "brandDetail.field_definitions")
        // Prepare Notes Parameter and update it into mandatory Actions
        parametersToUpdate.push({
            "name": "Notes",
            "display_name": "",
            "data_category": "",
            "data_type": "header",
            "dom_options": {
                "required": false,
                "label": false
            },
            "show_in_inbox_detail": true,
            "custom_parameter_type": 4,
            "group_id": "ltms_multiple_accordion_fields",
            "seq_no": 101,
            "field_id": "header_for_notes",
            "is_single_request_initiation": false
        });

        parametersToUpdate.push({
            "name": "Notes",
            "display_name": "Notes",
            "data_category": "profile_data",
            "data_type": "string",
            "dom_options": {
                "type": "multi-line",
                "rows": "3",
                "required": true
            },
            "show_in_inbox_detail": true,
            "custom_parameter_type": 4,
            "group_id": "ltms_multiple_accordion_fields",
            "seq_no": 102,
            "field_id": "ltms_custom_field_rca_notes",
            "is_single_request_initiation": false
        });

        // Remove notes in case of Multiple Mandatory Rule. As it has to be filled by the user dynamically. There is no prefilled data required at this point of time.
        if (_.get(mandatoryParameters, "issueDetail.tags.ltms_custom_field_rca_notes")) {
            mandatoryParameters.issueDetail.tags.ltms_custom_field_rca_notes = null;
        }
        console.log("mandatoryParameters::::", parametersToUpdate);
        console.log("notesParameter::::", notesParameter);
        console.log("\n ------------------------------------------------- \n");
    }

    prepareParamForMandatoryRule(mandatoryActionsToPerform:any, brandDetail:any, data:any, hasNotes?:any) {
        var tempFieldDefinitions:any = [];
        var groupSubFieldDefinitions:any = [];
        var fieldDefinitionsByGroup:any = [];
        var parentGroup:any = [];
        var popupHeader:string = "";
        var noOfAccordions:any = mandatoryActionsToPerform.length;
        var groupId:any = null;

        // Prepare parameters to be rendered on popup
        var paramsForMandatory = {
            issueDetail: data,
            issueId: data._id,
            brandDetail: brandDetail,
            action: {
                "action": "openPopup",
                "options": {
                    "group_id": "ltms_multiple_accordion_fields" // Provide a temp Id
                }
            },
            selectedStatus: data.status_id_list
        };

        // Loop through all the mandatory rules and fetch field_definfitons based on the rules
        _.each(mandatoryActionsToPerform, function (parameter:any, index:number) {
            groupId = _.get(parameter, "options.group_id");
            fieldDefinitionsByGroup = _.filter(paramsForMandatory["brandDetail"]["field_definitions"], { "group_id": groupId });
            parentGroup = _.filter(paramsForMandatory["brandDetail"]["field_definitions"], { "field_id": groupId });
            var groupTypeFields = _.filter(fieldDefinitionsByGroup, { "data_type": "group" })

            // Add seperator in case of multiple accordions
            if (noOfAccordions > 1 || hasNotes) {
                fieldDefinitionsByGroup.unshift({
                    "name": _.get(parentGroup, "0.name") || "",
                    "display_name": "",
                    "data_category": "",
                    "data_type": "header",
                    "dom_options": {
                        "required": false,
                        "label": false
                    },
                    "show_in_inbox_detail": true,
                    "custom_parameter_type": 4,
                    "group_id": "ltms_multiple_accordion_fields",
                    "seq_no": 1,
                    "field_id": "header_" + groupId,
                    "is_single_request_initiation": false
                })

                popupHeader = "Please provide the following details before proceeding";
            } else {
                if (_.get(parentGroup, "0.name")) {
                    popupHeader += (parentGroup[0]["name"] + (((noOfAccordions - 1) == index) ? " " : ", "));
                }
            }

            // Merge all the field definitions which needs to be rendered all at once
            if (groupTypeFields && groupTypeFields.length) {
                _.each(groupTypeFields, function (field_definition) {
                    if (field_definition && field_definition.dom_options && field_definition.dom_options.group_to_render) {
                        var data = _.filter(paramsForMandatory["brandDetail"]["field_definitions"], { "group_id": field_definition.dom_options.group_to_render });
                        if (data && data.length) {
                            groupSubFieldDefinitions = groupSubFieldDefinitions.concat(data)
                        }
                    }
                })
            }

            tempFieldDefinitions = tempFieldDefinitions.concat(fieldDefinitionsByGroup);
        });

        // Utils.getLoggedInAccessLevel(function (accessLevel:any) {
            // update field_definition's group Id so that multiple group can be rendered at same time
            _.each(tempFieldDefinitions,  (fieldDefinition:any, index:number) =>{
                fieldDefinition["seq_no"] = (index + 1);
                fieldDefinition["group_id"] = "ltms_multiple_accordion_fields";
            })
        // })
        tempFieldDefinitions = tempFieldDefinitions.concat(groupSubFieldDefinitions);
        // Push a temp parent group 
        tempFieldDefinitions.push({
            "name": popupHeader,
            "custom_parameter_type": 4,
            "group_id": null,
            "field_id": "ltms_multiple_accordion_fields",
            "show_in_inbox_detail": true,
            "is_single_request_initiation": false
        })
        paramsForMandatory["brandDetail"]["field_definitions"] = tempFieldDefinitions;

        return paramsForMandatory;
    }
}

